import React, { useState } from 'react';
import ReviewCard from './ReviewCard/ReviewCard';
import './reviews.css';

const Reviews = ({ reviews, loading, type = 'employee' }) => {
  const [showAll, setShowAll] = useState(false);
  const INITIAL_DISPLAY_COUNT = 3;

  if (loading) {
    return (
      <div className="reviews__loading">
        <p>Cargando reseñas...</p>
      </div>
    );
  }

  if (!reviews || reviews.length === 0) {
    return (
      <div className="reviews__empty">
        <p>{type === 'employee' ? 'Este empleado aún no tiene reseñas.' : 'Esta empresa aún no tiene reseñas.'}</p>
      </div>
    );
  }

  const displayedReviews = showAll ? reviews : reviews.slice(0, INITIAL_DISPLAY_COUNT);
  const hasMoreReviews = reviews.length > INITIAL_DISPLAY_COUNT;

  return (
    <div className="reviews__container">
      <h2 className="reviews__title">RESEÑAS ({reviews.length})</h2>
      <div className="reviews__list">
        {displayedReviews.map((review) => (
          <ReviewCard key={review.id} review={review} type={type} />
        ))}
      </div>
      {hasMoreReviews && !showAll && (
        <div className="reviews__actions">
          <button 
            className="reviews__show-more-button"
            onClick={() => setShowAll(true)}
          >
            Ver más reseñas ({reviews.length - INITIAL_DISPLAY_COUNT} más)
          </button>
        </div>
      )}
      {showAll && hasMoreReviews && (
        <div className="reviews__actions">
          <button 
            className="reviews__show-less-button"
            onClick={() => setShowAll(false)}
          >
            Ver menos
          </button>
        </div>
      )}
    </div>
  );
};

export default Reviews;

